import { render, staticRenderFns } from "./wxTreeNode.vue?vue&type=template&id=4a0e9b7b&scoped=true"
import script from "./wxTreeNode.vue?vue&type=script&lang=js"
export * from "./wxTreeNode.vue?vue&type=script&lang=js"
import style0 from "./wxTreeNode.vue?vue&type=style&index=0&id=4a0e9b7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e9b7b",
  null
  
)

export default component.exports